import React, { Component } from "react";
import { connect } from "react-redux";

const mapStateToProps = state => {
    return {
        pluginPath: state.appSettings.pluginPath
    }
}

class Languages extends Component {
    render() {
        var currencies = [
            {
                fullLabel: "Svensk krona",
                shortLabel: "SEK",
                icon: "se.png",
                path: "sek"
            },
            {
                fullLabel: "US Dollar",
                shortLabel: "USD",
                icon: "us.png",
                path: "usd"
            },
            {
                fullLabel: "Euro",
                shortLabel: "EUR",
                icon: "eu.png",
                path: "eur"
            },
            {
                fullLabel: "Pound Sterling",
                shortLabel: "GBP",
                icon: "uk.png",
                path: "gbp"
            },
        ];

        var currencyItems = currencies.map((item, key) => {
            return <a className="currency-item" href={"?currency=" + item.path} key={key}>
                <img className="currency-icon" src={this.props.pluginPath + "/assets/currency/" + item.icon} />
                <span className="title">{item.fullLabel}</span>
                <span className="subtitle">({item.shortLabel})</span>
            </a>
        })

        return <div className="other-languages-wrap">
            <span className="languages-title">Shop Veronica Virta in other currencies</span>

            <div className="items">
                { currencyItems }
            </div>
        </div>
    }
}

export default connect(mapStateToProps)(Languages);